import React from 'react';
import { View, StyleSheet, useWindowDimensions, Platform } from 'react-native';
import { useResponsive } from '@/hooks/common/useResponsive';
import { ADMIN_COLORS } from '@/constants/admin';

interface DesktopAdminLayoutProps {
  children: React.ReactNode;
}

export const DesktopAdminLayout: React.FC<DesktopAdminLayoutProps> = ({
  children,
}) => {
  const { layoutMode } = useResponsive();
  const { height: windowHeight } = useWindowDimensions();
  const contentHeight = Platform.OS === 'web' ? { height: windowHeight } : undefined;

  if (layoutMode !== 'desktop') {
    return <>{children}</>;
  }

  return (
    <View style={[styles.contentContainer, contentHeight]}>
      <View style={styles.contentArea}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    minWidth: 0,
    minHeight: 0,
  },
  contentArea: {
    flex: 1,
    padding: 24,
    maxWidth: '100%',
    overflow: 'visible',
    minHeight: 0,
  },
});
